import { render, staticRenderFns } from "./PlayerPointsStatistic.vue?vue&type=template&id=2a394536&scoped=true&"
import script from "./PlayerPointsStatistic.vue?vue&type=script&lang=js&"
export * from "./PlayerPointsStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a394536",
  null
  
)

export default component.exports